import { hooks, mui, React, ts, ui } from '_core';

import { DraftParams } from './types';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;
  context?: ts.types.signal.SignalAnalysisContext;
};

const Form = ({ params, setParams, context }: FormProps) => {
  const [comparets, setcomparets] = React.useState(params.analysis_time_series_ids || []);

  const [returnHorizons, setReturnHorizons] = React.useState<ts.types.returnHorizon.ReturnHorizon[]>(
    params.return_horizons || []
  );

  const [dailyReporting, setDailyReporting] = React.useState(params?.daily_reporting || false);

  const uiStyles = hooks.useUiStyles();

  React.useEffect(() => {
    const data = {
      ...params,
      return_horizons: returnHorizons,
      withBenchmark: false,
      daily_reporting: dailyReporting,
      agg_frequency: dailyReporting ? 'DAILY' : undefined,
      analysis_time_series_ids: comparets,
    } as DraftParams;
    setParams(data);
  }, [returnHorizons, dailyReporting, comparets]);

  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <mui.core.Box mt={4}>
        <ui.ResourceAutocomplete<ts.types.timeSeries.TimeSeriesExpanded, true>
          value={comparets}
          setValue={(ids) => setcomparets(ids)}
          type={ts.enums.RESOURCES_TYPES_ENUM.TIME_SERIES}
          autocompleteProps={{
            size: 'small',
            multiple: true,
            disableCloseOnSelect: true,
          }}
          inputProps={{
            label: 'Select Time Series',
            variant: 'outlined',
            size: 'small',
            required: true,
          }}
        />
      </mui.core.Box>

      <mui.core.Box mt={4}>
        <ui.WidgetReturnHorizon<true>
          value={returnHorizons}
          setValue={(val) => setReturnHorizons(val)}
          dailyReporting={dailyReporting}
          setDailyReporting={(val) => setDailyReporting(val)}
          multiple
          enableDailyReporting
          context={context}
          enableReturnsClipping={true}
        />
      </mui.core.Box>
    </mui.core.Box>
  );
};

export default Form;
